<template>
  <v-app>
    <v-app-bar
            app
            class="white"
            clipped-left
    >
      <v-btn icon @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <div class="d-flex align-center">
        <a href="https://cms.rs.sr">
          <v-img
                  class="shrink mr-2"
                  contain
                  src="./assets/bitlab-logo-wbmail-plavi.png"
                  transition="scale-transition"
                  width="80"
          />
        </a>
      </div>
      <v-spacer></v-spacer>

      <div style="width: 260px" class="pr-4">
        <v-row no-gutters align="center" class="fill-height">
          <v-autocomplete
                  v-model="site"
                  :items="websites"
                  outlined
                  dense
                  @change="changeSites"
                  hide-details
                  item-text="website"
                  item-value="id"
                  return-object
          ></v-autocomplete>
        </v-row>
      </div>
      <div style="width: 160px">
        <v-row no-gutters align="center" class="fill-height">
          <v-select
                  dense
                  :items="langs"
                  v-model="$i18n.locale"
                  @change="setLang"
                  outlined
                  item-text="text"
                  item-value="code"
                  hide-details
          ></v-select>
        </v-row>
      </div>
      <div style="width: 160px" class="pl-4">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
            >
              <v-icon>mdi-account</v-icon>
              Profile
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                    v-for="(item, index) in [{title: 'Profile', icon: 'mdi-account'}, {title: 'Logout', icon: 'mdi-lock-open-outline'}]"
                    :key="index"
                    @click=""
            >
              <v-list-item-title @click="item.title === 'Logout' ? logout() : $router.push({name: 'profil'})">
                <v-icon v-html="item.icon" small class="pr-2"></v-icon>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>

    </v-app-bar>
    <v-navigation-drawer app clipped v-if="$store.state.user" v-model="drawer">
      <!--            v-if="$store.state.user"-->
      <v-list dense nav>
        <template v-for="item in items">
          <template v-if="item.child">
            <v-list-group
                    no-action
                    value="true">
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="child in item.child">
                <v-list-item :to="child.to" link exact v-if="!child.hasOwnProperty('role') || child.role.includes($store.state.user.type)">
                  <v-list-item-content>
                    <v-list-item-title>{{ child.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <v-list-item :to="item.to" link exact
                       v-else-if="item.title !== 'Korisnici' && item.title !== 'Sajtovi' && item.title !== 'Opcije'">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="item.to" link exact v-else-if="$store.state.user.type === 1">
            <!--                        v-else-if="$store.state.user.type > 0"-->
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-content app class="grey lighten-4">
      <router-view class="pa-5" v-if="refresh"></router-view>
    </v-content>
  </v-app>
</template>

<script>

  export default {
    name: 'App',
    head() {
      return {
        title: 'BitLab CMS'
      }
    },
    data: () => ({
      drawer: true,
      items: [
        {title: 'Vijesti', icon: 'mdi-eye', to: {name: 'vijesti'}},
        {title: 'Vijesti Nove', icon: 'mdi-eye', to: {name: 'vijesti-nova'}},
        {title: 'Objekti', icon: 'mdi-cube', to: {name: 'objekti'}},
        {title: 'Stranice', icon: 'mdi-notebook', to: {name: 'stranice'}},
        {title: 'Dokumenta', icon: 'mdi-file-multiple', to: {name: 'dokumenta'}},
        {
          title: 'Kategorije', icon: 'mdi-shape', child: [
            {title: 'Kategorije dokumenata', to: {name: 'kategorije-dokumenti'}},
            {title: 'Kategorije objekata', to: {name: 'kategorije-objekti'}},
            {title: 'Kategorije stranice', to: {name: 'kategorije-stranice'}},
            {title: 'Kategorije vijesti', to: {name: 'kategorije-vijesti'}},
            {title: 'Kategorije kompanija', icon: 'mdi-domain', to: {name: 'kategorije-kompanije'}},
          ]
        },
        {
          title: 'Distribucija', icon: 'mdi-shape', child: [
            {title: 'Udruzenja', to: {name: 'distribucija-udruzenja'}, role: [1,3]},
            {title: 'Distributeri', to: {name: 'distribucija-distributeri'}, role: [1,2,3]},
            {title: 'Prodavci', to: {name: 'distribucija-prodavci'}, role: [1,4,3,2]},
            {title: 'Gradovi', icon: 'mdi-domain', to: {name: 'distribucija-gradovi'}, role: [1]},
          ]
        },
        {title: 'Fotografije', icon: 'mdi-image', to: {name: 'fotografije'}},
        {title: 'Video', icon: 'mdi-video ', to: {name: 'video'}},
        {title: 'Meni', icon: 'mdi-folder', to: {name: 'meni'}},
        {title: 'Proizvodi', icon: 'mdi-tag-multiple ', to: {name: 'proizvodi'}},
        {title: 'Kompanije', icon: 'mdi-domain', to: {name: 'kompanije'}},
        {title: 'Jezici', icon: 'mdi-web', to: {name: 'jezici'}},
        {title: 'Globalna podesavanja', icon: 'mdi-home', to: {name: 'index'}},
        {title: 'Korisnici', icon: 'mdi-account', to: {name: 'korisnici'}},
        {title: 'Narudzbine', icon: 'mdi-cart', to: {name: 'narudzbine'}},
        {title: 'Kontak Forme', icon: 'mdi-cart', to: {name: 'forme'}},
        {title: 'Sajtovi', icon: 'mdi-web', to: {name: 'sajtovi'}},
        {title: 'Opcije', icon: 'mdi-web', to: {name: 'settings'}},
        {title: 'Ankete', icon: 'mdi-web', to: {name: 'surveys'}},
      ],
      langs: [
        {text: 'Latinica', code: 'la'},
        {text: 'English', code: 'en'},
        {text: 'Ћирилица', code: 'cy'}
      ],
      site: null,
      refresh: true
    }),
    created() {
      this.setLang();
    },
    methods: {
      setLang() {
        let data = this.langs.find(lang => lang.code === this.$i18n.locale);
        this.$store.commit('SAVE_LANG', data)
      },
      changeSites() {
        this.$store.commit('SAVE_SITE', this.site);
        this.$store.commit('SAVE_LANGUAGES', []);
        this.refresh = false;
        setTimeout(() => {
          this.refresh = true
        }, 200)
      },
      logout() {
        localStorage.removeItem("bitlab-token");
        this.$store.commit('SAVE_USER', null)
        this.$router.push({name: 'logovanje'})
      }
    },
    computed: {
      websites() {
        return (this.$store.state.user && this.$store.state.user.website) || []
      }
    },
    watch: {
      '$store.state.site'() {
        this.site = this.$store.state.site
      }
    }
  };
</script>
